import React from "react";
import { default as Header } from "../header/Header";

const Home = ( { isLoggedIn }) => {
  return (
    <div>
      <Header isLoggedIn={ isLoggedIn }></Header>
    </div>
  );
};

export default Home;
